import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sku-generate-dialog',
  templateUrl: './sku-generate-dialog.component.html',
  styleUrls: ['./sku-generate-dialog.component.scss']
})
export class SkuGenerateDialogComponent implements OnInit,OnDestroy{
  copied: boolean;
  input = new FormControl('',[Validators.required]);
  private destroy$ = new Subject<void>();
  
  constructor( public dialogRef: MatDialogRef<SkuGenerateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,){
    
  }
  ngOnInit(): void {
    this.input.setValue(Math.random().toString().substring(2,12)?.toUpperCase());
  }

  close(){
    this.dialogRef.close()
  }

  action($event){
    this.dialogRef.close(this.input.value?.toUpperCase())
  }

  copy(e: MouseEvent) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
